import { User } from "../../classes/User";
import { encryptData, decryptData } from "../../../libs/utilities/helpers/Crypto";

export const Auth = {
    register: (encryptedUser) => {        
       if (encryptedUser) {
            localStorage.setItem("AuthUser", encryptedUser);
        }
    },


    setTxnId:  (txnId) => {
        let AuthUser = localStorage.getItem("AuthUser");
        if (!AuthUser) return null;

        const decrypted =  decryptData(AuthUser);
        AuthUser = JSON.parse(decrypted);

        if (AuthUser && AuthUser.Txnid !== undefined) {
            AuthUser.Txnid = txnId;

            const encrypted =  encryptData(JSON.stringify(AuthUser));
            localStorage.setItem("AuthUser", encrypted.data);
        }

        return AuthUser;
    },


    isLoggedIn:  () => {
        let AuthUser = localStorage.getItem("AuthUser");
        if (!AuthUser) return false;

        const decrypted =  decryptData(AuthUser);
        AuthUser = JSON.parse(decrypted);

        if (AuthUser && AuthUser.Token) {
            return true;
        } else {
            return false;
        }
    },
    


    deregister: () => {
        localStorage.clear();
    },

    //  getUser:  () => {
    //     let AuthUser = localStorage.getItem("AuthUser");
    //     if (!AuthUser) return null;
     
    //     const decrypted =  decryptData(AuthUser);
    //     AuthUser = JSON.parse(decrypted);
    //     return AuthUser;
    // },
    getUser: () => {
    try {
        let AuthUser = localStorage.getItem("AuthUser");
        if (!AuthUser) return null;

        const decrypted = decryptData(AuthUser);

        if (!decrypted || decrypted === "undefined") {
            throw new Error("Invalid decrypted data");
        }

        AuthUser = JSON.parse(decrypted);
        return AuthUser;

    } catch (err) {
        // console.error("getUser error:", err);

        localStorage.removeItem("AuthUser"); 
        return null;
    }
},


    setToken:  (token) => {
        let AuthUser = localStorage.getItem("AuthUser");
        if (!AuthUser) return;

        const decrypted =  decryptData(AuthUser);
        AuthUser = JSON.parse(decrypted);

        if (AuthUser) {
            AuthUser.Token = token;

            const encrypted =  encryptData(JSON.stringify(AuthUser));
            localStorage.setItem("AuthUser", encrypted.data);
        }
    },


     getToken:  () => {
        let token = "";
        let AuthUser = localStorage.getItem("AuthUser");
        if (!AuthUser) return token;

        const decrypted =  decryptData(AuthUser);
        AuthUser = JSON.parse(decrypted);

        if (AuthUser) {
            token = AuthUser.Token;
        }

        return token;
    },

};
